import Brightness7Icon from '@material-ui/icons/Brightness7';

const LightThemeIcon = Brightness7Icon;

export default LightThemeIcon;